<template>
  <v-layout wrap>
    <v-flex>
      <v-layout wrap v-if="jobs">
        <v-flex
          xs12
          sm12
          v-for="job in jobs"
          v-bind:key="job._id"
          class="list-section pa-2 mb-0 mb-3"
        >
          <div>
            <h3 class="headline mb-0">{{job.job.title || job.title}}</h3>            
            <div v-html="trimJobText(job.job.description)"></div>
            <br>
            <div>
              <b>Expertise Category:</b>
              {{job.job.category}}
            </div>
            <div>
              <b>Sub Category:</b>
              {{job.job.subcategory}}
            </div>
            <div>
              <b>Time Frame:</b>
              {{job.job.timeFrame}}
            </div>
            <div v-if="job.job.status ==  'expired' || job.job.expired == true">
              <b>
                Job Status:
                <span style="color: red">Expired</span>
              </b>
            </div>
            <div v-else-if="job.job.assigned ==  true">
              <b>
                Job Status:
                <span style="color: green">Assigned</span>
              </b>
            </div>
            <div v-else>
              <b v-if="job.job.active == true">
                Job Status:
                <span class="jobStatus">Available</span>
              </b>
              <b v-if="job.job.active == false">
                Job Status:
                <span style="color: red;">Deactivated. <a href="javascript:void(0)" @click="showContactModal" >Contact Support</a></span>
              </b>
            </div>
            <div>
              <b>Job Location:</b>
              {{job.job.location.locationName}}
            </div>
            <div>
              <b>Posted On:</b>
              {{job.job.createdAt | moment("DD MMMM YYYY") }}
            </div>
          </div>

          <div>
            <v-btn icon :to="`/sonko/job/details/${job.job._id}`">
              <v-icon color="green">visibility</v-icon>
            </v-btn>
            <v-btn icon :to="`/sonko/create/job?id=${job.job._id}`">
              <v-icon color="orange">edit</v-icon>
            </v-btn>
            <v-btn icon @click="deleteModal(job.job)">
              <v-icon color="red">delete</v-icon>
            </v-btn>
            <v-btn
              class="right btntext"
              flat
              color="red"
              v-if="job.job.assigned==true && job.job.expired == false"
              @click="uModal(job.job)"
            >Un-assign & Repost</v-btn>

            <v-btn
              class="right"
              color="blue"
              v-if="job.job.assigned==true && job.job.expired == false"
              flat
              :to="`/sonko/job/assigned/${job.job._id}?assigned=${job.job.assigned}`"
            >Assigned To</v-btn>
            <v-btn
              v-else-if="job.job.expired != true"
              flat
              class="right"
              color="orange"
              :to="`/sonko/job/engagements/${job.job._id}?assigned=${job.job.assigned}`"
            >
            <v-badge color="red" v-if="job.job.active == true">
                <template v-slot:badge>
                  <span>{{job.engagements.length}}</span>
                </template>
                <span>Bids</span>
              </v-badge>
            </v-btn>
          </div>
        </v-flex>

        <!-- delete dialog -->
        <v-dialog v-model="uDialog" max-width="600px">
          <v-toolbar class="primary" dark dense>
            <v-toolbar-title>Un-assign job</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="uDialog=false">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card>
            <v-layout wrap>
              <v-flex xs12 class="pa-2">
                <p>Are you sure you want to unassign the following job?</p>
                <span style="color: red">{{jobItem.title}}</span>
              </v-flex>
              <v-flex xs12>
                <v-btn :loading="loader" color="red" class="right" small dark @click="unassign">
                  <v-icon left>delete</v-icon>Yes
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-dialog>
        <!-- end of delete  -->

              <!-- delete dialog -->
      <v-dialog v-model="deleteDialog" max-width="600px">
        <v-toolbar class="red" dark dense>
          <v-toolbar-title>Delete Job</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="deleteDialog=false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
              <p>Are you sure you want to delete this job?</p>
              <p>{{jobItem.title}}</p>
            </v-flex>
            <v-flex xs12>
              <v-btn color="red" class="right" small dark @click="deleteJob">
                <v-icon left>delete</v-icon>Yes
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
      <!-- end of delete  -->

      <!-- report review modal -->
      <v-dialog v-model="reportModal" max-width="500px">
        <v-card>
          <v-toolbar color="primary" flat dense dark>
            <v-toolbar-title class="title">Contact Support</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" icon @click.native="reportModal=false">
              <v-icon color="white">clear</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <a :href="`https://wa.me/254777221441`" target="_blank">
                  <img src="@/assets/whatsapp.png" style="width: 40px; height: 40px;" alt="">
                </a>
              </v-flex>
              <v-flex xs12>
                  <span class="hidden-sm-and-down" style="color: #03a9f4"><v-icon class="green--text text--darken-1">phone</v-icon> +254777221441</span><a class="hidden-md-and-up pl-2" href="tel:+254777221441"><v-icon class="green--text text--darken-1">phone</v-icon> +254777221441</a>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- report review modal -->

      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { trimJobText } from "@/common/methods.js";
export default {
  name: "JobsList",
  props: {
    jobs: {
      type: Array,
      default: []
    },
    jobStatus: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters(["host"]),
    ...mapGetters(["user"])
  },
  data() {
    return {
      loader: false,
      jobItem: {},
      deleteDialog: false,
      deleteItem: {},
      uDialog: false,
      loader: false,
      reportModal: false
    };
  },
  methods: {
    trimJobText,
    deleteModal(data) {
      this.jobItem = Object.assign({}, data);
      this.deleteDialog = true;
    },
    uModal(data) {
      this.jobItem = Object.assign({}, data);
      this.uDialog = true;
    },
    unassign(id) {
      const data = {
        assigned: false,
        userId: this.jobItem.assignedTo
      };
      const job = this.jobItem;
      const self = this;
      self.loader = true;
      const res = this.$store
        .dispatch("put", { url: "/job/unassign/" + job._id, data })
        .then(res => {
          if(res.state) {
            location.reload();
          } 
        })
        .finally(() => {});
    },
    deleteJob(id) {
      const job = this.jobItem;
      const jobUser = this.user;
      const self = this;
      self.loader = true;
      const res = this.$store
        .dispatch("remove", "/job/modify/" + jobUser._id + '/' + job._id)
        .then(res => {
          if(res.state) {
            location.reload();
          } 
        })
        .finally(() => {});
    },
    showContactModal() {
      this.reportModal = true;
    }
  }
};
</script>
<style>
  .btntext {
    text-transform: none;
  }
  .jobStatus {
    color: #008000;
  }
</style>